import { Injectable } from "@angular/core";
import { Observable, catchError, tap, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ScaleStore } from "../scale.store";
import { EndPoint, getEndpoint } from "src/app/models/endpoint";
import { LoadingService } from "../loading.service";
import { AuthStore } from "../auth.store";
import { RegrasService } from "./regras.service";
import { Regra, RegraDTO } from "src/app/models/regra";


@Injectable()
export class RegrasHttpService extends RegrasService {

  constructor(
    private http: HttpClient,
    scaleStore: ScaleStore,
    private loadingService: LoadingService,
    private authStore: AuthStore
  ) {
    super(scaleStore);
  }

  //Add Loading
  //REFATORAR TODO

  public override atualizaSetoresBloqueados(regra: RegraDTO): Observable<Regra[] | any> {
    this.loadingService.presentLoading();

    return this.http.put(`${getEndpoint(EndPoint.ESCALA_PERIODO)}/regras`, [regra]).
      pipe(
        catchError((err: any): Observable<never> => {
          this.loadingService.dismissLoading();
          if (err.error.message) {
            this.loadingService.presentToast(err.error.message, 'danger')
          } else {
            const message = "Erro ao salvar sugestão"
            this.loadingService.presentToast(message)
          }

          return throwError(err);
        }),
        tap((r) => {
          console.log(r);
          this.loadingService.dismissLoading();
        }),
      )
  }

  public override atualizaRegrasMes(regras: Regra[]): Observable<Regra[] | any> {
    this.loadingService.presentLoading();

    return this.http.put(`${getEndpoint(EndPoint.ESCALA_PERIODO)}/regras`, regras).
      pipe(
        catchError((err: any): Observable<never> => {
          this.loadingService.dismissLoading();
          if (err.error.message) {
            this.loadingService.presentToast(err.error.message, 'danger')
          } else {
            const message = "Erro ao salvar regras"
            this.loadingService.presentToast(message)
          }

          return throwError(err);
        }),
        tap((r) => {
          console.log(r);
          this.loadingService.dismissLoading();
        }),
      )
  }

  public override carregaRegrasMes(escalaPeriodoId: number): Observable<Regra[] | any> {
    this.loadingService.presentLoading();
    return this.http.get(`${getEndpoint(EndPoint.ESCALA_PERIODO)}/${escalaPeriodoId}/regras`).
      pipe(
        catchError((err) => {
          this.loadingService.dismissLoading();
          if (err.error.message) {
            this.loadingService.presentToast(err.error.message, 'danger')
          } else {
            const message = "Erro ao carregar regras sugerias"
            this.loadingService.presentToast(message)
          }
          return throwError(err);
        }),
        tap((r) => {
          this.loadingService.dismissLoading();
        }),
      )
  }

}
